import { Button } from '@atoms';
import { ProductNode, Promotion } from '@datamodel';
import { useLanguage } from '@languageProvider';
import { Mixins, Spacing } from '@styles';
import { useTheme } from '@themeProvider';
import Animation from '@utils/animations';
import React, { useEffect, useRef } from 'react';
import { Animated, Pressable, StyleSheet, Text, View } from 'react-native';

const parsePrice = (price, currency = '') => {
    if (price === 0) {
        return _translate('free');
    }
    if (currency === '€') {// Round to 2 decimal places
        const roundedPrice = Math.round(price / 100).toFixed(2);

        // Remove trailing zeros
        const formattedPrice = parseFloat(roundedPrice).toString();
        return `${formattedPrice} ${currency}`;
    }
    return '';
}

export const FungibleCard = ({ product, offers = {}, couponAvailable, style, ...props }) => {
    const animation = useRef(new Animated.Value(0)).current;
    const { useColor, useElevation } = useTheme();
    const { translate } = useLanguage();
    const [title, label, primaryText, body, backgroundColor, secondary, primary] = useColor([
        'title',
        'label',
        'primary',
        'body',
        'background',
        'secondary',
        ['primary', { isText: true }]]);

    const [numberColor] = useColor([
        ['title', { on: primary }]
    ])

    const numberInCart = props.cartCount[product.nodeId] || 0;

    const elevation = useElevation(4);

    const soldOut = ProductNode.isSoldOut(product);

    const { promotionId: appliedOffer, price: finalPrice } = Promotion.calculateBestOffer(offers, product.uiPrice);

    const onMinusPress = () => {
        // Find selection id
        const selections = props.stackedCart.selections || {};
        const selId = Object.keys(selections).find(selId => selections[selId].item.nodeId === product.nodeId)
        if (selId) {
            props.setSelectionQuantity(selId)(numberInCart - 1);
        }
    }

    useEffect(() => {
        if (!numberInCart) {
            Animated.timing(animation, Animation.short(0)).start();
        } else if (numberInCart === 1) {
            Animated.timing(animation, Animation.short(1)).start();
        }
    }, [numberInCart])

    return (
        <Pressable {...props} disabled={soldOut} style={[style]}>

            {/* {
                !!soldOut &&
                <View style={{
                    position: 'absolute',
                    width: ProductNodeCard.HEIGHT,
                    height: ProductNodeCard.HEIGHT,
                    backgroundColor: Colors.setOpacity(label, .5),
                    ...Mixins.rounding(ProductNodeCard.HEIGHT)
                }} />
            } */}

            <View style={[{ paddingVertical: Spacing.S, paddingHorizontal: Spacing.M, }, Mixins.rounding(), elevation]}>
                <View style={[Mixins.HORIZONTAL, { flex: 1, alignItems: 'center' },]}>
                    <Text style={[styles.title, { color: soldOut ? label : title, flex: 1 }]}>{product.name}</Text>
                    <Text style={[styles.title, { color: soldOut ? label : title }]}>{parsePrice(finalPrice, '€')}  </Text>

                    <View style={[Mixins.HORIZONTAL, { gap: Spacing.XS, justifyContent: 'center', alignItems: 'center' }]}>
                        <View style={[Mixins.HORIZONTAL, {
                            gap: Spacing.XS, justifyContent: 'center', alignItems: 'center',
                            opacity: 1,
                            width: Button.HEIGHT + .5 * styles.title.fontSize + Spacing.XS,
                        }]}>
                            <Button disabled={soldOut} onPress={onMinusPress} status={numberInCart > 0 ? "default" : "disabled"} color={"primary"} icon="minus-alt" size="x-condensed" style={{ width: 28, padding: 0, justifyContent: 'center' }} />
                            <Text style={[styles.title, { color: soldOut ? label : title, flex: 1, textAlign: 'center' }]}>{numberInCart}</Text>
                        </View>
                        <Button disabled={soldOut} onPress={() => props.displayModal(product)} status={!soldOut ? "default" : "disabled"} color="primary" icon="add-alt" size="x-condensed" style={{ width: 28, padding: 0, justifyContent: 'center' }} />
                    </View>
                </View>
                {
                    !!product.description &&
                    <Text style={[styles.body, { color: body }]}>{product.description}</Text>
                }
            </View>

        </Pressable>
    )
}

const styles = StyleSheet.create({
    title: {
        fontSize: 14,
        lineHeight: 20,
        fontFamily: 'Poppins-SemiBold'
    },
    body: {
        fontSize: 14,
        lineHeight: 20,
        letterSpacing: '4%',
        fontFamily: 'Poppins-Regular'

    }
})
